module.exports = __webpack_public_path__ + "img/view-icon5.b0be400e.png";